enum PAYMENT_PROVIDERS {
  ADYEN_WEB = 'Adyen',
  NCCC = 'NCCC',
  GSI_PAYPAL = 'GSIPayPal',
  BRAINTREE = 'Braintree',
  AFTERPAY = 'AfterPay',
  IYZICO = 'Iyzico',
  RADIAL = 'Legacy',
  RADIAL_ALIPAY = 'RadialAliPay',
  INGENICO = 'Ingenico',
  MERCADO_PAGO = 'MercadoPago',
  GMORPay = 'GMORPay',
  COD = 'COD',
  LINE_PAY = 'LinePay',
  PAYPAL = 'PayPal',
  BELEZA = 'Beleza',
  MOCKPAY = 'MockPay',
  PAYU = 'PayU',
  ZERO_PAYMENT = 'ZeroPayment',
  GIFT_CARD = 'GiftCard',
  KUESKI = 'Kueski',
  TCTP = 'TCTP',
  GLOBAL_COLLECT = 'GlobalCollect',
  ALTAPAY = 'AltaPay',
  ASIAPAY = 'AsiaPay',
}

export enum PAYMENT_MODES {
  PAY_BY_LINK = 'PayByLink',
  NEW_CREDIT_CARD_PAYMENT_ID = 'NEW_CREDIT_CARD_PAYMENT_ID',
  CREDIT_CARD = 'CC',
  PAYPAL = 'PayPal',
  SOFORT = 'Sofort',
  ADYEN_WEB_CC = 'AWCCC',
  ADYEN_WEB_ALIPAY = 'AWCAliPay',
  ADYEN_WEB_PAYPAL = 'AWCPayPal',
  ADYEN_WEB_BOLETO = 'AWCBoleto',
  ADYEN_WEB_WECHATPAY = 'AWCWechatPay',
  ADYEN_WEB_KLARNA = 'AWCKlarna',
  ADYEN_WEB_KLARNA_ACCOUNT = 'AWCKlarnaAccount',
  ADYEN_WEB_GOOGLEPAY = 'AWCGooglepay',
  ADYEN_WEB_APPLEPAY = 'AWCApplePay',
  ADYEN_WEB_PIX = 'AWCPix',
  ADYEN_WEB_PAYPAY = 'AWCPayPay',
  ADYEN_WEB_RAKUTENPAY = 'AWCRakutenpay',
  MERCADO_PAGO_CC = 'PP_MPCC',
  MERCADO_PAGO_CASH = 'PP_CASH',
  MERCADO_PAGO_PSE = 'PP_PSE',
  MERCADO_PAGO_WEBPAY = 'PP_WEBPAY',
  VENMO = 'Venmo',
  KUESKI = 'Kueski',
  IDEAL = 'Ideal',
  CREDIT_CARD_VISA = 'Visa',
  AMEX = 'Amex',
  CREDIT_CARD_MASTERCARD = 'MC',
  MAESTRO_CARD = 'Maestro',
  VISA_ELECTRON = 'VisaElectron',
  ALTAPAY_CREDIT_CARD = 'CreditCard',
  ALTAPAY_MOBILE_PAY = 'MobilePay',
  ALTAPAY_KLARNA = 'Klarna',
  ASIAPAY_CREDIT_CARD = 'AsiaPayCreditCard',
  ASIAPAY_UNIONPAY = 'AsiaPayUnionPay',
  ASIAPAY_ALIPAY = 'AsiaPayAlipay',
  ASIAPAY_WECHAT_PAY = 'AsiaPayWechatPay',
}

export enum PAYMENT_TYPE {
  PP = 'PP',
  CC = 'CC',
  COD = 'COD',
}

export enum MERCADO_PAGO_TYPE {
  CREDIT_CARD = 'credit_card',
  DEBIT_CARD = 'debit_card',
  CASH = 'cash',
}

export const paymentScriptsSrc = Object.freeze({
  afterPayMessaging: 'https://js.afterpay.com/afterpay-1.x.js',
});

export default PAYMENT_PROVIDERS;
